import TvaController from './tva.controller';

export default {
    template: require('./tva.tpl.html'),
    controller: TvaController
};
